import { useMemo } from 'react'
import { useRouter } from 'next/router'

/**
 * Hook to detect if the current page has a custom background
 * @returns boolean indicating if the current page has a custom background
 */
export const useCustomBackgroundRoutes = () => {
  const router = useRouter()

  return useMemo(() => {
    const CUSTOM_BACKGROUND_ROUTES = [
      '/$dupe',
      '/$dupe/rewards',
      '/blog',
      '/press',
    ]
    return CUSTOM_BACKGROUND_ROUTES.some((route) =>
      router.pathname.startsWith(route)
    )
  }, [router.pathname])
}
